import service from './config'
class AllTeamService {
    getAllTeamList() {
        return service.get('/api/TeamMember/GetTeamMemberAllList')
    }
    AddAllTeam(param) {
        return service.post('/api/TeamMember/TabletAddTeamMember',param)
    }
    UpdateAllTeam(param) {
        return service.post('/api/TeamMember/TeamMemberUpdate',param)
    }
    DeleteAllTeam(param) {
        return service.delete('/api/TeamMember/TabletDeleteByIds',param)
    }
    DeleteTeam(param){
    	return service.delete('/api/TeamMember/TabletDeleteTeamMember',param)
    } 
    backToConcentrate(param){
    	return service.post('api/TeamMember/backtoconcentrate',param)
    }
    
    backToInside(param){
    	return service.post('api/TeamMember/BackToInside',param)
    }
    getTroopsTeamMemberStatus(){
        return service.get('api/TroopsInfo/GetTroopsTeamMemberStatus')
    }
}
export default new AllTeamService()